export const cardSize = [
    { name: "dummycard", width: '421', height:'614' },
    { name: "dummycardsmall", width: '168', height:'246' },
  ];
